import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firestore';
import { 
  collection, 
  addDoc, 
  getDocs, 
  deleteDoc, 
  doc, 
  updateDoc,
  query,
  orderBy,
  writeBatch
} from 'firebase/firestore';
import AdminCatalogForm from '../../Components/AdminCatalogForm';
import ImageUploader from '../../Components/ImageUploader';

const AdminCatalogPage = () => {
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showProductPopup, setShowProductPopup] = useState(false);
  const [showCategoryPopup, setShowCategoryPopup] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [editingCategory, setEditingCategory] = useState(null);
  const [activeTab, setActiveTab] = useState('products'); // 'products' или 'categories'
  
  const [productData, setProductData] = useState({
    type: 'product',
    name: '',
    category: '',
    description: '',
    features: [''],
    colors: ['#000000'],
    quality: 'Premium',
    specifications: {
      threadCount: '',
      weight: '',
      material: '',
    },
    image: '',
    videoUrl: '',
    videoDuration: '',
    link: '#'
  });

  const [categoryData, setCategoryData] = useState({
    name: '',
    description: '',
    image: '',
    order: 0,
    isActive: true
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoadingItems, setIsLoadingItems] = useState(true);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);

  const qualities = [
    { id: 'Premium', name: 'Premium' },
    { id: 'Luxury', name: 'Luxury' },
    { id: 'Exclusive', name: 'Exclusive' },
    { id: 'Professional', name: 'Professional' },
  ];

  // Функция для извлечения ID видео из RuTube URL
  const getRutubeId = (url) => {
    if (!url) return null;
    
    // Обрабатываем различные форматы RuTube URL
    const patterns = [
      /rutube\.ru\/video\/([a-zA-Z0-9_-]+)/,
      /rutube\.ru\/play\/embed\/([a-zA-Z0-9_-]+)/,
      /rutube\.ru\/video\/embed\/([a-zA-Z0-9_-]+)/,
      /rutube\.ru\/embed\/([a-zA-Z0-9_-]+)/,
      /rutube\.ru\/([a-zA-Z0-9_-]+)$/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    
    // Если URL не соответствует шаблонам, возвращаем null
    return null;
  };

  // Загрузка категорий
  const loadCategories = async () => {
    setIsLoadingCategories(true);
    try {
      const q = query(collection(db, "categories"), orderBy("order"));
      const querySnapshot = await getDocs(q);
      const categoriesList = [];
      querySnapshot.forEach((doc) => {
        categoriesList.push({ id: doc.id, ...doc.data() });
      });
      setCategories(categoriesList);
    } catch (err) {
      console.error('Ошибка при загрузке категорий:', err);
      setMessage('Ошибка при загрузке категорий');
    } finally {
      setIsLoadingCategories(false);
    }
  };

  // Загрузка товаров
  const loadItems = async () => {
    setIsLoadingItems(true);
    try {
      const querySnapshot = await getDocs(collection(db, "catalogItems"));
      const itemsList = [];
      querySnapshot.forEach((doc) => {
        itemsList.push({ id: doc.id, ...doc.data() });
      });
      // Сортируем по дате создания (новые первыми)
      itemsList.sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(0);
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(0);
        return dateB - dateA;
      });
      setItems(itemsList);
    } catch (err) {
      console.error('Ошибка при загрузке:', err);
      setMessage('Ошибка при загрузке данных');
    } finally {
      setIsLoadingItems(false);
    }
  };

  useEffect(() => {
    loadCategories();
    loadItems();
  }, []);

  // Обработчики для товаров
  const handleProductChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('specifications.')) {
      const specKey = name.split('.')[1];
      setProductData(prev => ({
        ...prev,
        specifications: {
          ...prev.specifications,
          [specKey]: value
        }
      }));
    } else {
      setProductData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleFeatureChange = (index, value) => {
    const newFeatures = [...productData.features];
    newFeatures[index] = value;
    setProductData(prev => ({
      ...prev,
      features: newFeatures
    }));
  };

  const addFeature = () => {
    setProductData(prev => ({
      ...prev,
      features: [...prev.features, '']
    }));
  };

  const removeFeature = (index) => {
    const newFeatures = [...productData.features];
    newFeatures.splice(index, 1);
    setProductData(prev => ({
      ...prev,
      features: newFeatures
    }));
  };

  const handleColorChange = (index, value) => {
    const newColors = [...productData.colors];
    newColors[index] = value;
    setProductData(prev => ({
      ...prev,
      colors: newColors
    }));
  };

  const addColor = () => {
    setProductData(prev => ({
      ...prev,
      colors: [...prev.colors, '#000000']
    }));
  };

  const removeColor = (index) => {
    const newColors = [...productData.colors];
    newColors.splice(index, 1);
    setProductData(prev => ({
      ...prev,
      colors: newColors
    }));
  };

  // Обработчики для категорий
  const handleCategoryChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCategoryData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Сохранение товара
  const handleProductSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');



    try {
const cleanedData = {
  ...productData,
  category: productData.category || 'catalog',
  features: productData.features.filter(f => f.trim() !== '')
};


      // Извлекаем ID RuTube видео если URL указан
      if (cleanedData.videoUrl) {
        const rutubeId = getRutubeId(cleanedData.videoUrl);
        if (rutubeId) {
          cleanedData.rutubeId = rutubeId;
        }
        
        if (!cleanedData.videoDuration) {
          setMessage('Пожалуйста, укажите длительность видео');
          setLoading(false);
          return;
        }
      }

      if (editingItem) {
        await updateDoc(doc(db, "catalogItems", editingItem.id), {
          ...cleanedData,
          updatedAt: new Date()
        });
        setMessage('Товар успешно обновлен!');
      } else {
        await addDoc(collection(db, "catalogItems"), {
          ...cleanedData,
          createdAt: new Date(),
          updatedAt: new Date()
        });
        setMessage('Товар успешно добавлен!');
      }

      resetProductForm();
      loadItems();
    } catch (err) {
      console.error('Ошибка при сохранении товара:', err);
      setMessage('Ошибка при сохранении товара');
    } finally {
      setLoading(false);
    }
  };

  // Сохранение категории
  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    if (!categoryData.name.trim()) {
      setMessage('Пожалуйста, укажите название категории');
      setLoading(false);
      return;
    }

    try {
      if (editingCategory) {
        await updateDoc(doc(db, "categories", editingCategory.id), {
          ...categoryData,
          updatedAt: new Date()
        });
        setMessage('Категория успешно обновлена!');
      } else {
        // Определяем порядок для новой категории
        const newOrder = categoryData.order || categories.length;
        await addDoc(collection(db, "categories"), {
          ...categoryData,
          order: newOrder,
          createdAt: new Date(),
          updatedAt: new Date()
        });
        setMessage('Категория успешно добавлена!');
      }

      resetCategoryForm();
      loadCategories();
    } catch (err) {
      console.error('Ошибка при сохранении категории:', err);
      setMessage('Ошибка при сохранении категории');
    } finally {
      setLoading(false);
    }
  };

  // Удаление товара
  const handleDeleteProduct = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот товар?')) {
      try {
        await deleteDoc(doc(db, "catalogItems", id));
        setItems(items.filter(item => item.id !== id));
        setMessage('Товар успешно удален');
      } catch (err) {
        console.error('Ошибка при удалении товара:', err);
        setMessage('Ошибка при удалении товара');
      }
    }
  };

  // Удаление категории
  const handleDeleteCategory = async (categoryId) => {
    // Проверяем, есть ли товары в этой категории
    const productsInCategory = items.filter(item => item.category === categoryId);
    
    if (productsInCategory.length > 0) {
      if (!window.confirm(`В этой категории есть ${productsInCategory.length} товар(ов). Все они будут удалены. Продолжить?`)) {
        return;
      }
    }

    if (window.confirm('Вы уверены, что хотите удалить эту категорию?')) {
      try {
        const batch = writeBatch(db);
        
        // Удаляем категорию
        batch.delete(doc(db, "categories", categoryId));
        
        // Удаляем все товары в этой категории
        productsInCategory.forEach(product => {
          batch.delete(doc(db, "catalogItems", product.id));
        });
        
        await batch.commit();
        
        setMessage('Категория и связанные товары удалены');
        loadCategories();
        loadItems();
      } catch (err) {
        console.error('Ошибка при удалении категории:', err);
        setMessage('Ошибка при удалении категории');
      }
    }
  };

  // Редактирование товара
// Редактирование товара
const handleEditProduct = (item) => {
  setEditingItem(item);
  setProductData({
    type: 'product',
    name: item.name || '',
    category: item.category || '',
    description: item.description || '',
    features: item.features && item.features.length > 0 ? item.features : [''],
    colors: item.colors && item.colors.length > 0 ? item.colors : ['#000000'],
    quality: item.quality || 'Premium',
    specifications: {
      threadCount: item.specifications?.threadCount || '',
      weight: item.specifications?.weight || '',
      material: item.specifications?.material || '',
    },
    images: item.images || (item.image ? [item.image] : []), // ← ИЗМЕНИТЬ ЭТУ СТРОКУ
    videoUrl: item.videoUrl || '',
    videoDuration: item.videoDuration || '',
    link: item.link || '#'
  });
  setShowProductPopup(true);
  setMessage('');
};

  // Редактирование категории
  const handleEditCategory = (category) => {
    setEditingCategory(category);
    setCategoryData({
      name: category.name || '',
      description: category.description || '',
      image: category.image || '',
      order: category.order || 0,
      isActive: category.isActive !== undefined ? category.isActive : true
    });
    setShowCategoryPopup(true);
    setMessage('');
  };

  // Сброс форм
  const resetProductForm = () => {
    setProductData({
      type: 'product',
      name: '',
      category: '',
      description: '',
      features: [''],
      colors: ['#000000'],
      quality: 'Premium',
      specifications: {
        threadCount: '',
        weight: '',
        material: '',
      },
      image: '',
      videoUrl: '',
      videoDuration: '',
      link: '#'
    });
    setEditingItem(null);
    setShowProductPopup(false);
  };

  const resetCategoryForm = () => {
    setCategoryData({
      name: '',
      description: '',
      image: '',
      order: categories.length,
      isActive: true
    });
    setEditingCategory(null);
    setShowCategoryPopup(false);
  };

const getCategoryName = (id) => {
  if (!id || id === 'catalog') return 'Каталог тканей';

  const category = categories.find(cat => cat.id === id);
  return category ? category.name : 'Каталог тканей';
};


  const getQualityName = (id) => {
    const quality = qualities.find(q => q.id === id);
    return quality ? quality.name : id;
  };

  // Функция для изменения порядка категорий
  const handleReorderCategory = async (categoryId, direction) => {
    const categoryIndex = categories.findIndex(c => c.id === categoryId);
    if ((direction === 'up' && categoryIndex === 0) || 
        (direction === 'down' && categoryIndex === categories.length - 1)) {
      return;
    }

    const newIndex = direction === 'up' ? categoryIndex - 1 : categoryIndex + 1;
    const updatedCategories = [...categories];
    
    // Меняем порядок в массиве
    [updatedCategories[categoryIndex], updatedCategories[newIndex]] = 
    [updatedCategories[newIndex], updatedCategories[categoryIndex]];
    
    // Обновляем порядок в Firestore
    try {
      const batch = writeBatch(db);
      updatedCategories.forEach((cat, index) => {
        const catRef = doc(db, "categories", cat.id);
        batch.update(catRef, { order: index });
      });
      await batch.commit();
      
      // Обновляем локальное состояние
      setCategories(updatedCategories);
      setMessage('Порядок категорий обновлен');
    } catch (err) {
      console.error('Ошибка при изменении порядка:', err);
      setMessage('Ошибка при изменении порядка');
    }
  };

  return (
    <div
      className="
        h-screen
        overflow-y-auto
        overscroll-y-contain
        bg-gradient-to-br from-gray-900 via-black to-gray-900
        text-white
        p-4
      "
      style={{
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <div className="max-w-6xl mx-auto pb-24">

        {/* Заголовок */}
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-500 rounded-lg flex items-center justify-center mr-3">
              <span className="text-black font-bold text-xl">ET</span>
            </div>
            <div>
              <h1 className="text-3xl font-bold bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                ХОРЕКА Admin
              </h1>
              <p className="text-gray-400">Панель управления каталогом</p>
            </div>
          </div>
        </div>

        {/* Табы для переключения */}
        <div className="mb-8">
          <div className="flex border-b border-gray-700">
            <button
              onClick={() => setActiveTab('products')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'products'
                  ? 'text-amber-500 border-b-2 border-amber-500'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              Товары
            </button>
            <button
              onClick={() => setActiveTab('categories')}
              className={`px-6 py-3 font-medium transition-colors ${
                activeTab === 'categories'
                  ? 'text-amber-500 border-b-2 border-amber-500'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              Категории
            </button>
          </div>
        </div>

        {/* Контент для товаров */}
        {activeTab === 'products' && (
          <>
            {/* Кнопки управления товарами */}
            <div className="flex space-x-4 mb-8">
              <button
                onClick={() => {
                  setEditingItem(null);
                  resetProductForm();
                  setShowProductPopup(true);
                }}
                className="px-6 py-3 bg-gradient-to-r from-amber-600 to-orange-500 text-white font-bold rounded-lg hover:opacity-90 transition-opacity flex items-center"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Добавить товар
              </button>
              {categories.length === 0 && (
                <button
                  onClick={() => {
                    setActiveTab('categories');
                    setShowCategoryPopup(true);
                  }}
                  className="px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-500 text-white font-bold rounded-lg hover:opacity-90 transition-opacity flex items-center"
                >
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
                  </svg>
                  Сначала добавьте категорию
                </button>
              )}
            </div>

            {/* Список товаров */}
            <div className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-white">Добавленные товары</h2>
              
              {isLoadingItems ? (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500 mx-auto"></div>
                  <p className="text-gray-400 mt-2">Загрузка товаров...</p>
                </div>
              ) : items.length === 0 ? (
                <div className="text-center py-8 bg-gray-800/50 rounded-xl border border-gray-700">
                  <p className="text-gray-400">Нет добавленных товаров. Добавьте первый товар.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {items.map((item) => (
                    <div key={item.id} className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden">
                      <div className="p-4">
                        <div className="flex justify-between items-start mb-3">
                          <div>
                            <h3 className="font-bold text-white truncate">{item.name}</h3>
                            <p className="text-sm text-gray-400">
                              {getCategoryName(item.category)} • {getQualityName(item.quality)}
                            </p>
                          </div>
                          {item.videoUrl && (
                            <span className="px-2 py-1 bg-red-500/20 text-red-300 rounded text-xs">Есть видео (RuTube)</span>
                          )}
                        </div>
                        
                        {item.image && (
                          <img 
                            src={item.image} 
                            alt={item.name}
                            className="w-full h-40 object-cover rounded-lg mb-3"
                          />
                        )}
                        
                        <p className="text-sm text-gray-300 mb-3 line-clamp-2">{item.description}</p>
                        
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex -space-x-2">
                          </div>
                          <div className="text-xs text-gray-400">
                            {item.specifications?.material && <span>{item.specifications.material}</span>}
                          </div>
                        </div>
                        
                        {item.videoUrl && (
                          <div className="mb-3 p-2 bg-red-900/20 rounded-lg">
                            <div className="flex items-center text-xs text-red-300">
                              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd"/>
                              </svg>
                              RuTube видео: {item.videoDuration || '0:00'}
                            </div>
                          </div>
                        )}
                        
                        <div className="flex justify-between items-center">
                          <div className="text-xs text-gray-400">
                            {new Date(item.createdAt?.toDate ? item.createdAt.toDate() : item.createdAt).toLocaleDateString('ru-RU')}
                          </div>
                          <div className="flex space-x-2">
                            <button
                              onClick={() => handleEditProduct(item)}
                              className="px-3 py-1 bg-blue-500/20 text-blue-300 rounded-lg hover:bg-blue-500/30 text-sm"
                            >
                              Редактировать
                            </button>
                            <button
                              onClick={() => handleDeleteProduct(item.id)}
                              className="px-3 py-1 bg-red-500/20 text-red-300 rounded-lg hover:bg-red-500/30 text-sm"
                            >
                              Удалить
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}

        {/* Контент для категорий */}
        {activeTab === 'categories' && (
          <>
            {/* Кнопки управления категориями */}
            <div className="flex space-x-4 mb-8">
              <button
                onClick={() => {
                  setEditingCategory(null);
                  resetCategoryForm();
                  setShowCategoryPopup(true);
                }}
                className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-500 text-white font-bold rounded-lg hover:opacity-90 transition-opacity flex items-center"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Добавить категорию
              </button>
            </div>

            {/* Список категорий */}
            <div className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-white">Категории товаров</h2>
              
              {isLoadingCategories ? (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-500 mx-auto"></div>
                  <p className="text-gray-400 mt-2">Загрузка категорий...</p>
                </div>
              ) : categories.length === 0 ? (
                <div className="text-center py-8 bg-gray-800/50 rounded-xl border border-gray-700">
                  <p className="text-gray-400">Нет добавленных категорий. Добавьте первую категорию.</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {categories.map((category, index) => {
                    const productCount = items.filter(item => item.category === category.id).length;
                    return (
                      <div key={category.id} className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden">
                        <div className="p-4">
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center">
                              <div className="flex flex-col mr-4">
                                <button
                                  onClick={() => handleReorderCategory(category.id, 'up')}
                                  disabled={index === 0}
                                  className={`p-1 ${index === 0 ? 'text-gray-600' : 'text-gray-400 hover:text-white'}`}
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
                                  </svg>
                                </button>
                                <button
                                  onClick={() => handleReorderCategory(category.id, 'down')}
                                  disabled={index === categories.length - 1}
                                  className={`p-1 ${index === categories.length - 1 ? 'text-gray-600' : 'text-gray-400 hover:text-white'}`}
                                >
                                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                  </svg>
                                </button>
                              </div>
                              
                              {category.image ? (
                                <img 
                                  src={category.image} 
                                  alt={category.name}
                                  className="w-12 h-12 object-cover rounded-lg mr-3"
                                />
                              ) : (
                                <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center mr-3">
                                  <span className="text-gray-400 font-bold">{category.name.charAt(0)}</span>
                                </div>
                              )}
                              
                              <div>
                                <h3 className="font-bold text-white">{category.name}</h3>
                                <p className="text-sm text-gray-400">
                                  {productCount} товар(ов) • 
                                  <span className={`ml-2 px-2 py-0.5 rounded text-xs ${category.isActive ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
                                    {category.isActive ? 'Активна' : 'Неактивна'}
                                  </span>
                                </p>
                              </div>
                            </div>
                            
                            <div className="flex space-x-2">
                              <button
                                onClick={() => handleEditCategory(category)}
                                className="px-3 py-1 bg-blue-500/20 text-blue-300 rounded-lg hover:bg-blue-500/30 text-sm"
                              >
                                Редактировать
                              </button>
                              <button
                                onClick={() => handleDeleteCategory(category.id)}
                                className="px-3 py-1 bg-red-500/20 text-red-300 rounded-lg hover:bg-red-500/30 text-sm"
                              >
                                Удалить
                              </button>
                            </div>
                          </div>
                          
                          {category.description && (
                            <p className="text-sm text-gray-300 mb-2">{category.description}</p>
                          )}
                          
                          <div className="text-xs text-gray-400">
                            Порядок: {category.order + 1}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </>
        )}

        {/* Попап товара */}
        {showProductPopup && (
          <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
            <AdminCatalogForm
              productData={productData}
              categories={categories}
              qualities={qualities}
              loading={loading}
              message={message}
              isEditing={!!editingItem}
              onProductChange={handleProductChange}
              onFeatureChange={handleFeatureChange}
              onAddFeature={addFeature}
              onRemoveFeature={removeFeature}
              onColorChange={handleColorChange}
              onAddColor={addColor}
              onRemoveColor={removeColor}
              onSubmit={handleProductSubmit}
              onCancel={resetProductForm}
              getRutubeId={getRutubeId} // Передаем функцию в форму
            />
          </div>
        )}

        {/* Попап категории */}
        {showCategoryPopup && (
          <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
            <div className="bg-gray-800 rounded-xl border border-gray-700 max-w-md w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-white">
                    {editingCategory ? 'Редактировать категорию' : 'Добавить категорию'}
                  </h2>
                  <button
                    onClick={resetCategoryForm}
                    className="text-gray-400 hover:text-white"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {message && (
                  <div className={`mb-4 p-3 rounded-lg ${message.includes('успешно') ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
                    {message}
                  </div>
                )}

                <form onSubmit={handleCategorySubmit}>
                  <div className="space-y-4">
                    {/* Название категории */}
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">
                        Название категории *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={categoryData.name}
                        onChange={handleCategoryChange}
                        className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                        placeholder="Например: Скатерти"
                        required
                      />
                    </div>

                    {/* Описание */}
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">
                        Описание
                      </label>
                      <textarea
                        name="description"
                        value={categoryData.description}
                        onChange={handleCategoryChange}
                        rows="3"
                        className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                        placeholder="Описание категории"
                      />
                    </div>

                    {/* Изображение категории */}
                    <ImageUploader
                      label="Изображение категории"
                      hint="Рекомендуется 400x400px"
                      value={categoryData.image}
                      onChange={(url) =>
                        setCategoryData((prev) => ({ ...prev, image: url }))
                      }
                    />

                    {/* Порядок */}
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">
                        Порядок отображения
                      </label>
                      <input
                        type="number"
                        name="order"
                        value={categoryData.order}
                        onChange={handleCategoryChange}
                        min="0"
                        className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                      />
                    </div>

                    {/* Активность */}
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        name="isActive"
                        id="isActive"
                        checked={categoryData.isActive}
                        onChange={handleCategoryChange}
                        className="w-4 h-4 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500 focus:ring-2"
                      />
                      <label htmlFor="isActive" className="ml-2 text-sm text-gray-300">
                        Категория активна (отображается в каталоге)
                      </label>
                    </div>
                  </div>

                  <div className="flex justify-end space-x-3 mt-8">
                    <button
                      type="button"
                      onClick={resetCategoryForm}
                      className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors"
                      disabled={loading}
                    >
                      Отмена
                    </button>
                    <button
                      type="submit"
                      className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-500 text-white font-bold rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50"
                      disabled={loading}
                    >
                      {loading ? 'Сохранение...' : editingCategory ? 'Обновить' : 'Добавить'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminCatalogPage;